import { render, staticRenderFns } from "./InsMedia.vue?vue&type=template&id=06b74fee&scoped=true&"
import script from "./InsMedia.vue?vue&type=script&lang=ts&"
export * from "./InsMedia.vue?vue&type=script&lang=ts&"
import style0 from "./InsMedia.vue?vue&type=style&index=0&id=06b74fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b74fee",
  null
  
)

export default component.exports